import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
// This file is autogenerated. Any changes will be overwritten in next build.

const Check = props => {
  const {
    size,
    color
  } = props;
  const sizeMap = {
    sm: 20,
    md: 24,
    lg: 28
  };
  let sizeValue = size;
  if (typeof size === 'number') {
    sizeValue = size;
  } else if (typeof size === 'string') {
    sizeValue = sizeMap[size];
  }
  return /*#__PURE__*/_jsxs("svg", {
    width: sizeValue,
    height: sizeValue,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("rect", {
      width: "16",
      height: "16",
      rx: "2",
      fill: "transparent"
    }), /*#__PURE__*/_jsx("path", {
      d: "M13.3333 4.62225L6.22158 12.0889L2.66666 8.35559",
      stroke: color,
      strokeWidth: "1.77778",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  });
};
export { Check };